import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { markJobComplete} from "../../services/auth.service";
import { toast } from "react-toastify";
import { useDispatch,useSelector } from 'react-redux';
import { setLoader } from '../../slice/commonSlice';
import { toast_error } from '../../config/Constant';
import './MarkJobComplete.scss';
import { selectUser } from "../../slice/authSlice";

const MarkJobComplete = ({ jobId, setMarkComplete, MarkComplete }) => {
    const dispatch = useDispatch();
    const user = useSelector(selectUser);
    let userId = user.id

    const handleSubmit = async () => {
        console.log("id",jobId._id)
        const payload = {
            jobId:jobId._id,
            userId,
            jobStatus : "CO"
        };
        console.log("payload",payload)

        dispatch(setLoader(true));
        try {
            const response = await markJobComplete(payload);
            dispatch(setLoader(false));

            if (response?.data?.status) {
              
                setMarkComplete(false);
            } else {
                toast.error(response?.data?.message, toast_error);
            }
        } catch (error) {
            dispatch(setLoader(false));
            toast.error(error?.response?.data?.message || "Error marking job complete", toast_error);
            console.error("Error marking job complete:", error);
        }
    };

    return (
        <Modal
            size="sm"
            show={MarkComplete}
            onHide={() => setMarkComplete(false)}
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton />
            <Modal.Body>
                <div className='logout-form-wrapper'>
                    <div className='logout-title'>Mark Complete</div>
                    <div className='logout-message'>Are you sure you want to mark complete?</div>
                    <div className='raise-dispute'>
                       
                        <div className='w-100 logout-btn-wrapper'><Button onClick={handleSubmit} variant='outline-primary'>Yes</Button> <Button onClick={()=>setMarkComplete(false)} variant='outline-primary'>No</Button></div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default MarkJobComplete;
